'use client';

import { useEffect } from 'react';
import { useSearchStore } from '@/stores/search-store';

/**
 * Single global keyboard shortcut handler.
 * Mount once in the root layout to handle Cmd+K / Ctrl+K.
 */
export function useGlobalShortcuts() {
  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        const store = useSearchStore.getState();
        if (store.isOpen) {
          store.close();
        } else {
          store.open();
        }
      }
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
}
